import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core';
import { useWatch } from 'react-hook-form';
import frequencyTypes from 'constants/frequencyTypes';
import ChargeForSuspensionChx from './components/ChargeForSuspensionChx';
import SuspensionPaymentFrequencyDdl from './components/SuspensionPaymentFrequencyDdl';
import SuspensionFeeTxt from './components/SuspensionFeeTxt';
import styles from './components/styles';

const SuspensionChargeOption = (props) => {
  const {
    classes,
    register,
    control,
    setValue,
    canChargeForSuspension,
    currentSuspension,
    suspensionInfo,
    errors,
  } = props;
  const [
    disableSuspensionFeeAndFrequency,
    setDisableSuspensionFeeAndFrequency,
  ] = useState(true);
  const { isFuture } = currentSuspension;
  const enableCharegeForSuspension =
    (canChargeForSuspension || suspensionInfo.suspensionFee === null) &&
    isFuture;

  const watchChargeForSuspension = useWatch({
    control,
    name: 'chargeForSuspension',
  });

  useEffect(() => {
    //when change for suspension checkbox is disabled, the suspension fee and frequency are disabled as well.
    if (enableCharegeForSuspension) {
      if (!watchChargeForSuspension) {
        setValue('suspensionFee', 0);
        setValue('suspensionPaymentFrequency', frequencyTypes.OneOff.value);
      } else {
        const { suspensionFee, suspensionPaymentFrequency } = currentSuspension;
        setValue('suspensionFee', suspensionFee);
        setValue('suspensionPaymentFrequency', suspensionPaymentFrequency);
      }
      setDisableSuspensionFeeAndFrequency(!watchChargeForSuspension);
    }
  }, [
    watchChargeForSuspension,
    enableCharegeForSuspension,
    setValue,
    currentSuspension,
  ]);

  return (
    <div className={classes.Container}>
      <ChargeForSuspensionChx
        disabled={!enableCharegeForSuspension}
        classes={classes}
        register={register}
      />
      <SuspensionFeeTxt
        disabled={disableSuspensionFeeAndFrequency}
        classes={classes}
        register={register}
        errors={errors}
      />
      <SuspensionPaymentFrequencyDdl
        disabled={disableSuspensionFeeAndFrequency}
        classes={classes}
        control={control}
      />
    </div>
  );
};

export default withStyles(styles)(SuspensionChargeOption);
